import { render, staticRenderFns } from "./bracket_edit.vue?vue&type=template&id=277ade5c&scoped=true&"
import script from "./bracket_edit.vue?vue&type=script&lang=js&"
export * from "./bracket_edit.vue?vue&type=script&lang=js&"
import style0 from "./bracket_edit.vue?vue&type=style&index=0&id=277ade5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277ade5c",
  null
  
)

export default component.exports